import { render, staticRenderFns } from "./AddStreet.vue?vue&type=template&id=55b29255&scoped=true"
import script from "./AddStreet.vue?vue&type=script&lang=js"
export * from "./AddStreet.vue?vue&type=script&lang=js"
import style0 from "./AddStreet.vue?vue&type=style&index=0&id=55b29255&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b29255",
  null
  
)

export default component.exports